import { Languages } from 'lucide-react';
import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from './ui/select';
import { useI18n } from '../contexts/LanguageContext';
import { LANGUAGES, LANGUAGE_CATEGORIES } from '../lib/languages';

// Giriş ve kayıt ekranlarının sağ üstündeki dil seçici (kategorilere ayrılmış, yalnız etkin diller)
const CATEGORY_NAMES: Record<string, string> = {
  major: '🌟 Ana Diller / Major',
  europe: '🇪🇺 Avrupa / Europe',
  turkicCaucasus: '🏔️ Türki & Kafkas',
  middleEast: '🕌 Orta Doğu',
  southAsia: '🇮🇳 Güney Asya',
  southeastAsia: '🌴 G.Doğu Asya',
  africa: '🌍 Africa',
  other: '🌏 Diğer',
};

export function LanguagePicker() {
  const { language, setLanguage } = useI18n();
  return (
    <Select value={language} onValueChange={(value: string) => {
      setLanguage(value as any);
      localStorage.setItem('appLanguage', value);
    }}>
      <SelectTrigger className="w-36 sm:w-44 h-9 sm:h-10 bg-white/90 backdrop-blur-sm shadow-md text-xs sm:text-sm">
        <Languages className="w-3 h-3 sm:w-4 sm:h-4 mr-1 sm:mr-2" />
        <SelectValue />
      </SelectTrigger>
      <SelectContent className="max-h-[300px] sm:max-h-[400px] overflow-y-auto">
        {Object.entries(LANGUAGE_CATEGORIES).map(([categoryKey, langCodes]) => (
          <div key={categoryKey}>
            <div className="px-2 py-1 text-[10px] sm:text-xs font-semibold text-gray-500 bg-gray-50 sticky top-0">
              {CATEGORY_NAMES[categoryKey] || categoryKey}
            </div>
            {(langCodes as string[]).map(code => {
              const lang = LANGUAGES.find(l => l.code === code);
              if (!lang || !lang.enabled) return null;
              return (
                <SelectItem key={code} value={code} className="text-xs sm:text-sm py-1.5 sm:py-2">
                  {lang.flag} {lang.nativeName}
                </SelectItem>
              );
            })}
          </div>
        ))}
      </SelectContent>
    </Select>
  );
}
